import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 16" {...props}><path d="M21 7H3.376l5.18-5.3A1 1 0 007.125.3l-6.84 7a1 1 0 000 1.4l6.84 7a1 1 0 001.431-1.4L3.376 9H21a1 1 0 000-2z" fill="#4343f0" /></svg>);